// source: design/src/pages/WMSPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_ja';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-wms.jpg',
  heroTitle: '倉庫管理システム（WMS）',
  heroTagline: 'インテリジェント倉庫管理、効率的な物流運営',
  intro: [
    'WMS（Warehouse Management System）は、入庫から庫内管理、出庫までの全工程を最適化する専用の情報システムです。',
    '現代のWMSシステムはバーコード/RFID技術により在庫のリアルタイム可視化を実現し、ウェーブ計画、ロケーション最適化などのインテリジェントなアルゴリズムと組み合わせることで、倉庫作業の効率と在庫精度を大幅に向上させます。',
    '飛狼は企業にWMSシステムの計画、実装、統合サービスを提供し、ERP、MES、AGVなどのシステムとのシームレスな連携を支援します。',
  ],
  modules: [
    {
      icon: 'si/si-icons/arrow-left-right.svg',
      title: '入出庫管理',
      desc: '入庫と出庫の全工程を統合し、受入予約、品質検査・棚上げ、出荷検品、積載配車、輸送引き継ぎをカバー。PDAモバイル端末での操作をサポートし、正確かつタイムリーな出荷受入を保障します。',
    },
    {
      icon: 'si/si-icons/shopping-basket.svg',
      title: 'ピッキング管理',
      desc: '按件ピッキング、一括ピッキング、ウェーブピッキング、ゾーニングピッキングなどの複数戦略をサポートし、ピッキング経路を最適化します。',
    },
    {
      icon: 'si/si-icons/clipboard-check.svg',
      title: '在庫棚卸',
      desc: '動的在庫棚卸、定期棚卸、差異分析により、在庫精度が99.5%以上に達します。',
    },
    {
      icon: 'si/si-icons/qr-code.svg',
      title: 'バーコード/RFID',
      desc: '一次元コード/二次元コード/RFIDのマルチモードをサポートし、全工程のペーパーレス作業を実現します。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: 'レポートとKPI',
      desc: '在庫回転率、出入庫効率、注文履行率などの重要指標をリアルタイムに監視します。',
    },
    {
      icon: 'si/si-icons/layers-3.svg',
      title: '自動倉庫（AS/RS）',
      desc: '自動化立体倉庫（AS/RS）システムとの統合をサポートし、高密度保管、自動入出庫、スタッカー/シャトルの協調スケジューリングを実現します。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/shopping-cart.svg',
      title: 'EC物流',
      desc: '大規模セールのピーク時の注文処理、マルチチャネル在庫共有、迅速な返品交換処理をサポートし、日次処理能力は10万注文以上に達します。',
    },
    {
      icon: 'si/si-icons/factory.svg',
      title: '製造業',
      desc: '原材料倉庫と製品倉庫の一体化管理を実現し、生産出庫、製品入庫のMES連携をサポートします。',
    },
    {
      icon: 'si/si-icons/store.svg',
      title: '小売配送',
      desc: '店舗補充、クロスドッキング、配送経路の最適化により、配送定時率が98%以上に達します。',
    },
    {
      icon: 'si/si-icons/thermometer.svg',
      title: '医薬品低温物流',
      desc: '温湿度監視、ロット有効期限管理、GSPコンプライアンスにより、薬品の安全性と品質を保障します。',
    },
  ],
  agvTitle: 'WMSとAGV/ロボット倉庫の連携',
  agvTitleEn: 'Coordination between WMS and AGV/robotic warehousing',
  agvSteps: [
    {
      step: '01',
      title: 'WMSタスク配信',
      desc: 'WMSが注文に基づいてピッキング・搬送タスクを生成',
    },
    {
      step: '02',
      title: 'AGVスケジュール実行',
      desc: 'AGV制御システムがタスクを受信し、最適経路を自動計画',
    },
    {
      step: '03',
      title: 'リアルタイム状態フィードバック',
      desc: 'AGVがタスク完了後、自動的にWMSに在庫更新を送信',
    },
  ],
  agvArchitecture: 'システム統合アーキテクチャ',
  agvWms: 'WMS',
  agvWmsLabel: '倉庫管理システム',
  agvController: 'AGV Controller',
  agvControllerLabel: 'AGV制御システム',
  agvFleet: 'Robot Fleet',
  agvFleetLabel: 'ロボット群',
  benefits: [
    {
      number: '99.5%',
      title: '在庫精度',
      desc: 'バーコード/RFIDによる全工程追跡、リアルタイム在庫可視化',
    },
    {
      number: '30-50%',
      title: 'ピッキング効率向上',
      desc: 'インテリジェントなウェーブ計画と経路最適化により、移動距離を削減',
    },
    {
      number: '20%',
      title: '空間利用率向上',
      desc: 'インテリジェントなロケーション割り当てと動的ロケーション最適化',
    },
    {
      number: '40%',
      title: '注文履行時間短縮',
      desc: '自動化作業プロセスにより、人的待ち時間を削減',
    },
  ],
};
